<template>
    <div class="base-ro-input">
        <label class="text-sm font-semibold text-secondary-600 dark:text-darkblue-400 black:text-darkblue-500 block mb-1">{{ label }}</label>
        <span :class="{ 'mini-input-height': mini, 'min-input-height': !mini }" class="min-input-height flex items-center border-b border-solid border-gray-100 dark:text-darkblue-200 black:text-darkblue-500 dark:border-darkblue-600 whitespace-pre-wrap">{{ data }}</span>
    </div>
</template>

<script>
export default {
  name: 'read-only-input',
  props: {
    label: {
      type: String,
      default: ''
    },
    data: {
      type: String,
      default: ''
    },
    mini: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .min-input-height {
    padding: .25rem 0 0.70rem 0;
  }
  .mini-input-height {
    padding: .2rem 0 0.30rem 0;
  }
</style>
